import React, {ReactElement} from "react";
import classes from './Skills.module.scss';
import {Skill} from "./Skill";

const Skills = (): ReactElement => {
	return (
		<div className={classes.root}>
			<h2>Zkušenosti</h2>
			<Skill name="React" percent={100}/>
			<Skill name='TypeScript' percent={100}/>
			<Skill name='Python' percent={100}/>
			<Skill name="C#" percent={80}/>
			<Skill name='Git' percent={80}/>
			<Skill name="Linux" percent={80}/>
			<Skill name='VMWare' percent={70}/>
			<Skill name='SQL' percent={60}/>
		</div>
	)
}

export default Skills